export default __webpack_public_path__ + "static/helium-1c0042b295c58ad332c438ec87495bd1.svg";